import printComponent from './customer_report.component';

let printModule = angular.module('customerReportPrint', [
])
    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/branchManagement.customerPickupReports');

        $stateProvider
            .state('customerReportPrint', {
                url: '/print-customer-report',
                component: 'customerReportPrint',
                data: {
                    requireLogin: true,
                    requireACL: 'branch_mgmt_customer_pickup_reports.all'
                },
            })
    })

    .component('customerReportPrint', printComponent)

    .name;

export default printModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/customer_pickup_reports/print/index.js